<template>
  <ProjectTable
      :items="items"
      @operation="onOperation"
  />
</template>

<script>
  import ProjectTable from "./ProjectTable.vue";
  import {API} from "../../../../helpers/api-endpoints";
  import {Operations} from "../../../../helpers/roles";

  export default {
    name: 'ProjectList',
    components: {ProjectTable},
    data() {
      return {
        items: [],
        totalCount: 0,
      };
    },
    mounted() {
      this.loadProjects();
    },
    methods: {
      onOperation({ type, payload }) {
        switch (type) {
          case Operations.CREATE:
            this.$router.push({ name: 'adminProjectCreate' });
            break;

          case Operations.VIEW:
            this.$router.push({
              name: 'adminProjectView',
              params: { code: payload }
            });
            break;

          case Operations.EDIT:
            this.$router.push({
              name: 'adminProjectEdit',
              params: { code: payload }
            });
            break;
        }
      },
      loadProjects() {
        this.$loading(true);

        const searchCriteria = {
          offset: 0,
          max: 50,
          distinct: true,
          restrictBy: 'AND',
          meta: {},
          selectFields: ['*'],
        };

        this.$http
            .post(API.PROJECT_SEARCH, searchCriteria)
            .then(({ data }) => {
              console.log("data", data);
              this.items = data.resultList || [];
              this.totalCount = data.totalCount || 0;
            })
            .catch((err) => {
              console.error("Erreur lors du chargement des projets :", err);
              this.$toast.error("Erreur lors du chargement des projets");
            })
            .finally(() => this.$loading(false));
      },
      goEdit(code) {
        this.$router.push({ name: 'adminProjectEdit', params: { code } });
      },
      goView(code) {
        this.$router.push({ name: 'adminProjectView', params: { code } });
      },
    },
  };
</script>
